import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class DesignersList extends ThemeComponent {
    @Prop({default: ''}) class!: string;
}
